<template>
  <div 
    class="sc-message--preview" 
    :style="{ 'background-image': 'url(' + message.data.preview + ')' }"
    v-ripple 
    role="button" 
    v-on:click="clicked"
    :id="message.id"
  >
    <div class="sc-message--preview-icon" v-if="hasTimerIcon">
      <v-icon large>{{timerIcon}}</v-icon>
    </div>
    <div class="sc-message--preview-icon play-icon" v-else>
      <v-icon large>play_circle_outline</v-icon>
    </div>

    <div class="sc-message--preview-state">
      <MessageState :state="state" :time="time" background />
    </div>

    <MediaGallery :visible.sync="visible" :message="message" :progress="progress" />
  </div>

</template>

<style>
  .play-icon i {
    color:var(--v-primary-base) !important;
  }
  .play-icon:hover{
    opacity:1;
  }
</style>

<script>
  //<v-icon large v-if="message.data.ttl!=0 && message.state!=3 && !message.sent"  class="sc-message--image-icon play-icon" >bomb</v-icon>
  import MediaGallery from './../MediaGallery.vue'
  import MessageState from './MessageState.vue'
  import timeUtils from '@utils/timeUtils'

  export default {
    components: { 
      MediaGallery,
      MessageState 
    },
    props: {
      message:{
        type: Object,
        required: true
      }
    },
    data: () => ({
      visible: false
    }),
    methods:{
      clicked() {
        // TODO: event to open gallery page
        this.visible = true
      }
    },
    computed: {
      timerIcon() {
        return this.message.state == this.states.MessageRead ? 'history' : 'visibility'
      },
      hasTimerIcon() {
        return this.message.data.ttl != 0 && !this.message.sent
      },
      time() {
        return timeUtils.getShortTime(this.message.time);
      },
      state() {
        return this.message.sent ? this.message.state : null
      }
    }
}
</script>

